module.exports = __webpack_public_path__ + "static/img/14.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/14.png
// module id = VHDv
// module chunks = 0